import { createFileRoute, Link } from '@tanstack/react-router';
import { ItemIncidentDetailPanel } from '@/components/features/item-incident/ItemIncidentDetailPanel';

/** シートのデータは4行目から。それより前や数字でない値は依頼として扱わない */
/** @graph-connects none */
const FIRST_DATA_ROW = 4;

/**
 * 一覧とは別ページにしている。一覧の上に詳細を差し込む形だと、開くたびに一覧が下へずれて
 * どこを見ていたか分からなくなるため（2026-10-31 鷲澤要望）。Slack 通知のリンク先もここ。
 *
 * @graph-node {Page}
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business アイテム確認依頼の詳細ページ。確認内容の全文を表示し、バイヤー一覧に載っている人は回答とステータスを保存できる
 * @graph-connects ItemIncidentDetailPanel [calls] 依頼の詳細と回答フォーム
 */
export const Route = createFileRoute('/item-incident_/$rowNumber')({
  component: ItemIncidentDetailPage,
});

/** @graph-connects none */
function ItemIncidentDetailPage() {
  const { rowNumber } = Route.useParams();
  const row = Number(rowNumber);
  const valid = Number.isInteger(row) && row >= FIRST_DATA_ROW;

  return (
    <div className="max-w-4xl mx-auto">
      <Link
        to="/item-incident"
        className="inline-block text-sm px-2 py-1 -mx-2 mb-3 rounded-md cursor-pointer transition-colors hover:bg-[var(--color-bg-hover)]"
        style={{ color: 'var(--color-primary)' }}
      >
        ← アイテム確認依頼の一覧へ
      </Link>
      {valid ? (
        <ItemIncidentDetailPanel rowNumber={row} />
      ) : (
        <p role="alert" className="text-sm" style={{ color: 'var(--color-error)' }}>
          依頼の番号が正しくありません。一覧から開き直してください。
        </p>
      )}
    </div>
  );
}
